import { Currency } from '@core/pricing-types';

import { isEurRegion } from './is-eur-region';
import { isGbpRegion } from './is-gbp-region';
import { isUsdRegion } from './is-usd-region';

export const getCountryAvailableCurrencies = (countryCode: string): Currency | null => {
  if (isUsdRegion(countryCode)) return Currency.USD;
  if (isGbpRegion(countryCode)) return Currency.GBP;
  if (isEurRegion(countryCode)) return Currency.EUR;
  return null;
};
